import { graphql } from 'msw'
import { testCallBackUrls } from './data'

const testCallBackUrlHandlers = [
  graphql.query('testCallbackUrl', (req, res, ctx) => {
    const { applicationId, ...testCallbackUrl } = testCallBackUrls.find(
      (entry) => entry.applicationId === req.variables.applicationId
    )
    return res(ctx.data({ testCallbackUrl }))
  }),
]

export default testCallBackUrlHandlers
